import type { NavItemWithIconName } from '@/config';
import type { AddonApp } from '../types';

export const ADDON_APP_ROUTE_PREFIX = '/apps';

// Builds the sidebar "Apps" group; returns nothing when there are no apps so no empty headline shows
export function buildAddonAppsNavigation(addonApps: AddonApp[]): NavItemWithIconName[] {
  if (addonApps.length === 0) {
    return [];
  }

  const headline: NavItemWithIconName = { id: 'apps-headline', labelKey: 'sidebar.apps', isHeadline: true };
  return [headline, ...addonApps.map(toAddonAppNavItem)];
}

// labelKey stays as fallback because NavItem requires it; the backend name is shown via label
function toAddonAppNavItem(addonApp: AddonApp): NavItemWithIconName {
  return {
    id: `addon-app-${addonApp.slug}`,
    labelKey: 'sidebar.apps',
    label: addonApp.name,
    href: `${ADDON_APP_ROUTE_PREFIX}/${addonApp.slug}`,
    iconName: 'dashboard',
  };
}
